<template>
  <div 
    v-bind="$attrs" 
    class="BcTabPanel__Wrapper" 
    :class="{'bg-white rounded': bg }" 
    v-if="tabs"
  >
    <div>
      <bc-contractable-menu class="mx-3 sm:mx-0 mb-3">
        <template #left="{ contractLeft }">
          <nav 
            class="flex items-center" 
            :class="{'contractedPills': contractLeft}" 
            aria-label="Tabs"
            v-aw-driver-element="'ComponentTabPanelTabs'"
          >
            <!-- Tab links -->
            <slot/>
          </nav>
        </template>

        <!-- Filters + Add button -->
        <template #right="{ contractRight }">
          <div
            class="FiltersWrapper | w-auto flex items-center flex-row space-x-2 justify-end"
            :class="{ 'pr-4': bg }"
          >
            <slot 
              name="filters" 
              v-bind="{ filters, contractRight }"
            />
            <slot 
              name="right"
              v-bind="{ contractRight }"
            />
          </div>
        </template>
      </bc-contractable-menu>
    </div>
  </div>

  <slot name="table"/>
</template>

<script>
export default {
  props: {
    filters: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Boolean,
      default: true
    },
    bg: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="scss">
.BcTabPanel__Wrapper {
  margin-top: -6px;

  @media (min-width: 1200px) {
    margin-top: -8px;
  }
}

.TabPanel--Sticky {
  position: sticky;
  top: 90px;
  padding-top: 12px;
  z-index: 15;
  background: #fff;
}

.FiltersWrapper {
  >form {
    @apply flex flex-row space-x-2;

    >.InputCalendar__WrapperDropdown {
      width: 140px;
    }
  }
}

.FiltersWrapper:has(.pill-Contracted) {
  @apply w-auto;

  >form:has(.pill-Contracted) {
    @apply w-auto;
  }
}

@media (max-width: 767px) {
  .Calendar {
    width: 100% !important;
  }

  .FiltersWrapper {
    > * {
      @apply w-full flex justify-end;
    }

    > *:last-child {
      margin-right: 0 !important;
    }
  }
}

.contractedPills {
  .pill__Tab {
    @apply px-2;

    svg {
      @apply mr-0;
    }

    span {
      @apply hidden;
    }
  }
}
</style>
